import Vue from "vue";
import VueI18n from "vue-i18n";
import { getNavigatorLanguage } from "./../assets/utils";
import store from "./../store";

import en from "./en";
import es from "./es";
import bn from "./bn";
import lv from "./lv";

Vue.use(VueI18n);

const messages = {
  en, es, bn, lv
}

let lang = getNavigatorLanguage()
store.commit('setLang', lang)

export default new VueI18n({
  locale: lang,
  messages
})



// WEBPACK FOOTER //
// ./src/i18n/index.js